<div class="side-menu">
  <tds-side-menu aria-label="Side menu" id="side-menu" persistent open="{{ isMenuOpened }}">
    <tds-side-menu-overlay slot="overlay" (click)="mobileMenuAction(false)"></tds-side-menu-overlay>
    <tds-side-menu-close-button slot="close-button" aria-label="Close drawer menu" (click)="mobileMenuAction(false)"></tds-side-menu-close-button>
    @for (menu of menus; track menu.title) { 
      @if (menu.subMenu) {
        <tds-side-menu-dropdown id="wheel-types-dropdown" default-closed>
          <tds-icon slot="icon" name="{{ menu.icon }}" size="24px"></tds-icon>
          <span slot="label">{{ menu.title }}</span>
          <tds-side-menu-dropdown-list>
            @for (sub of menu.subMenu; track sub.title) {
              <tds-side-menu-dropdown-list-item>
              <a (click)="navigate(sub.path)">{{ sub.title }}</a>
              </tds-side-menu-dropdown-list-item>
            }
          </tds-side-menu-dropdown-list>
        </tds-side-menu-dropdown>
      } @else {
          <tds-side-menu-item>
            <button (click)="navigate(menu.path)">
              <tds-icon name="{{ menu.icon }}" size="24px"></tds-icon>
              {{ menu.title }}
            </button>
          </tds-side-menu-item>
        } 
      }

    <tds-side-menu-collapse-button slot="sticky-end">Collapse</tds-side-menu-collapse-button>
  </tds-side-menu>
</div>
